import { Component, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@toevla-webapplications/core';

@Component({
    selector: 'ivva-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [TranslateModule, CoreModule]
})
export class HelpComponent {
	show = signal(false);

	toggle() {
		this.show.update((show) => !show);
	}
}
